import InjuryCompensationForm from "./InjuryCompensationForm";
import WhyChooseInjuryCompensation from "./WhyChooseInjuryCompensation";
import SectionTwo from "./SectionTwo";
import SectionThree from "./SectionThree";
import SectionFour from "./SectionFour";
import SectionFive from "./SectionFive";
import SectionSix from "./SectionSix";
import SectionSeven from "./SectionSeven";
import SectionEight from "./SectionEight";
import Footer from "./Footer";

const InjuryCompensationMain = () => {
    return (
        <>
            <InjuryCompensationForm />
            {/* <AccidentTypes /> */}
            {/* <AutoAccidentRecovery /> */}
            <SectionTwo />
            <SectionThree/>
            <SectionFour />
            <SectionFive />
            <SectionSix />
            <SectionSeven/>
            <SectionEight />
            <WhyChooseInjuryCompensation />
            <Footer />
            
            {/* <LegalDisclaimerFooter /> */}
        </>
    );
};

export default InjuryCompensationMain;
